module.exports = __webpack_public_path__ + "img/logos.82883c8c.png";